"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
function TextBtn(props) {
    var value = props.value, title = props.title, body = props.body, className = props.className, style = props.style;
    function handleClick() {
        antd_1.Modal.confirm({
            className: 'coupon-modal',
            title: title,
            content: react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: body || '' } }),
            closable: true,
        });
    }
    return (react_1.default.createElement("span", { className: (0, classnames_1.default)('header-rule', className), style: style, onClick: handleClick }, value));
}
exports.default = TextBtn;
//# sourceMappingURL=TextBtn.js.map